import { useMemo, useState } from 'react';
import { ToggleTab } from 'src/components/primitives/ToggleTabs/types';
import { StakingAction } from 'src/components/Staking/types';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

interface Params {
	/**
	 * Defaults to `stake`.
	 */
	initialTab?: StakingAction;
}

export default function useStakingTabs({ initialTab = 'stake' }: Params = {}) {
	const isGeoblocked = useVelocityStore((s) => s.isGeoblocked);
	const [selectedTab, setSelectedTab] = useState<StakingAction>(
		isGeoblocked ? 'unstake' : initialTab
	);

	const tabOptions = useMemo(
		(): ToggleTab<StakingAction>[] => [
			{ value: 'stake', label: 'Stake', disabled: isGeoblocked },
			{ value: 'unstake', label: 'Unstake' },
		],
		[isGeoblocked]
	);

	return { tabOptions, selectedTab, setSelectedTab };
}
